import React from 'react';
import './SuperInvoice.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoaderBigTwo from '../../Shared/LoaderBigTwo/LoaderBigTwo';

const SuperInvoice = () => {
    const [activeTab, setActiveTab] = useState(1); // Set the default active tab to 2 (Tab 2)

    // Function to handle tab click
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    const [AllApplication, setAllApplication] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalInputData, setTotalInputData] = useState(0);

    const fetchArea = async () => {
        try {
            const response = await fetch('https://tutor-tree-server-1.vercel.app/verifyingDataMainData');
            const data = await response.json();
            setAllApplication(data);

            // Calculate total sum of "inputData"
            const sum = data.reduce((acc, item) => acc + parseFloat(item.inputData), 0);
            setTotalInputData(sum);

            setLoading(false);
        } catch (error) {
            console.error('Error fetching Districts:', error);
        }
    };

    useEffect(() => {
        fetchArea();
    }, []);


    const [Verify, setVerify] = useState([]);
    const [loadingTwo, setLoadingTwo] = useState(true);
    const [totalInputDataVerify, setTotalInputDataVerify] = useState(0);


    const fetchVerify = async () => {
        try {
            const response = await fetch('https://tutor-tree-server-1.vercel.app/verifyMainData');
            const data = await response.json();
            setVerify(data);
            const sum = data.reduce((acc, item) => acc + parseFloat(item.inputData), 0);
            setTotalInputDataVerify(sum);
            setLoadingTwo(false);
        } catch (error) {
            console.error('Error fetching Districts:', error);
        }
    };
    useEffect(() => {
        fetchVerify();
    }, []);


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 16; // Set the number of items to display per page
    const maxPageButtons = 5; // Set the maximum number of pagination buttons to display

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = AllApplication.slice(indexOfFirstItem, indexOfLastItem);

    const totalPageCount = Math.ceil(AllApplication.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const generatePaginationButtons = () => {
        const pageButtons = [];
        let startPage = 1;
        let endPage = totalPageCount;

        if (totalPageCount > maxPageButtons) {
            if (currentPage <= Math.ceil(maxPageButtons / 2)) {
                endPage = maxPageButtons;
            } else if (currentPage > totalPageCount - Math.floor(maxPageButtons / 2)) {
                startPage = totalPageCount - maxPageButtons + 1;
            } else {
                startPage = currentPage - Math.floor(maxPageButtons / 2);
                endPage = currentPage + Math.floor(maxPageButtons / 2);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageButtons.push(
                <li key={i}>
                    <button
                        onClick={() => handlePageChange(i)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${currentPage === i ? 'text-blue-600 bg-blue-50' : ''
                            }`}
                    >
                        {i}
                    </button>
                </li>
            );
        }

        return pageButtons;
    };

    /////////////////


    const [currentPageTwo, setCurrentPageTwo] = useState(1);
    const itemsPerPageTwo = 16;
    const maxPageButtonsTwo = 5;

    const indexOfLastItemTwo = currentPageTwo * itemsPerPageTwo;
    const indexOfFirstItemTwo = indexOfLastItemTwo - itemsPerPageTwo;
    const currentItemsTwo = Verify.slice(indexOfFirstItemTwo, indexOfLastItemTwo);

    const totalPageCountTwo = Math.ceil(Verify.length / itemsPerPageTwo);

    const handlePageChangeTwo = (pageNumber) => {
        setCurrentPageTwo(pageNumber);
    };

    const generatePaginationButtonsTwo = () => {
        const pageButtons = [];
        let startPage = 1;
        let endPage = totalPageCountTwo;

        if (totalPageCountTwo > maxPageButtonsTwo) {
            if (currentPageTwo <= Math.ceil(maxPageButtonsTwo / 2)) {
                endPage = maxPageButtonsTwo;
            } else if (currentPageTwo > totalPageCountTwo - Math.floor(maxPageButtonsTwo / 2)) {
                startPage = totalPageCountTwo - maxPageButtonsTwo + 1;
            } else {
                startPage = currentPageTwo - Math.floor(maxPageButtonsTwo / 2);
                endPage = currentPageTwo + Math.floor(maxPageButtonsTwo / 2);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageButtons.push(
                <li key={i}>
                    <button
                        onClick={() => handlePageChangeTwo(i)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${currentPageTwo === i ? 'text-blue-600 bg-blue-50' : ''
                            }`}
                    >
                        {i}
                    </button>
                </li>
            );
        }

        return pageButtons;
    };

    return (
        <div>
            <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
                <h2 className='headingTxt'>All Invoice / Pending Payment</h2>
            </div>
            <div className='px-5 mt-5'>
                <div className='w-full sm:w-full h-28  flex flex-row lg:gap-5 sm:gap-2 justify-around py-10'>
                    <button onClick={() => handleTabClick(1)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Verify Payment</button>
                    <button onClick={() => handleTabClick(2)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Pending Payment</button>
                    <button onClick={() => handleTabClick(3)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Partial Payment</button>
                    <button onClick={() => handleTabClick(4)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Overdue Invoices</button>
                    <button onClick={() => handleTabClick(5)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Paid Invoices</button>
                </div>


                {/* Content for Tab 1 */}
                {activeTab === 1 && (
                    <div className="tab-content w-full h-96 ">


                        <div>
                            {loading ? (
                                <div className='flex justify-center items-center '><LoaderBigTwo></LoaderBigTwo></div>
                            ) : (
                                <div>

                                    <div class="relative overflow-x-auto">
                                        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                            <thead class="">
                                                <tr>
                                                    <th scope="col" class="px-6 py-3">

                                                        <h1 className="TableHeaderText" >Name</h1>

                                                    </th>
                                                    <th scope="col" class="px-6 py-3">

                                                        <h1 className="TableHeaderText" >Amount</h1>

                                                    </th>

                                                    <th scope="col" class="px-6 py-3">
                                                        <h1 className="TableHeaderText" >Due Date</h1>
                                                    </th>

                                                    <th scope="col" class="px-6 py-3">
                                                        <h1 className="TableHeaderText" >Remainder</h1>
                                                    </th>
                                                    <th scope="col" class="px-6 py-3">
                                                        <h1 className="TableHeaderText" >Details</h1>
                                                    </th>
                                                </tr>
                                            </thead>
                                            {
                                                currentItems.map((all, index) => (

                                                    <tbody key={index} className='w-full text-sm text-left text-gray-500 dark:text-gray-400'>
                                                        <tr class="bg-white dark:bg-gray-800">
                                                            <th scope="row" class="px-6 py-4 tableBodyText dark:text-white">
                                                                {all.StudentsJobID}
                                                            </th>
                                                            <th scope="row" class="px-6 py-4 tableBodyText dark:text-white">
                                                                {all.inputData}
                                                            </th>
                                                            <td class="px-6 py-4">
                                                                {all.StartDate}
                                                            </td>
                                                            <td class="px-6 py-4">
                                                                {all.EndDate}
                                                            </td>


                                                            <td>
                                                                <Link to={`/dashboardTwo/SuperInvoiceDetails/${all._id}`}>
                                                                    <button className='text-white bg-orange-500 w-20 h-10 rounded-lg'>View</button>
                                                                </Link>
                                                            </td>


                                                        </tr>
                                                    </tbody>

                                                ))
                                            }
                                            <thead class="">
                                                <tr>
                                                    <th scope="col" class="px-6 py-3">


                                                    </th>
                                                    <th scope="col" class="px-6 py-3">

                                                        <h1 className="TotalText" >Total: {totalInputData}</h1>

                                                    </th>

                                                    <th scope="col" class="px-6 py-3">
                                                    </th>

                                                    <th scope="col" class="px-6 py-3">
                                                    </th>
                                                    <th scope="col" class="px-6 py-3">

                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>


                                    <div className='flex items-center justify-center mt-10'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="inline-flex -space-x-px text-sm">
                                                <li>
                                                    <button
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
                                                            }`}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>
                                                {generatePaginationButtons()}
                                                <li>
                                                    <button
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${currentPage === totalPageCount ? 'opacity-50 cursor-not-allowed' : ''
                                                            }`}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            )}

                        </div>

                    </div>
                )}

                {/* Content for Tab 2 */}
                {activeTab === 2 && (
                    <div className='w-full h-96'>
                        2


                    </div>
                )}

                {/* Content for Tab 3 */}
                {activeTab === 3 && (
                    <div className='w-full h-96'>

                        3
                    </div>
                )}
                {activeTab === 4 && (



                    <div className='w-full h-96'>
                        4
                    </div>
                )}
                {activeTab === 5 && (
                    <div>
                        <div className="tab-content w-full h-96 ">


                            <div>
                                {loading ? (
                                    <div className='flex justify-center items-center '><LoaderBigTwo></LoaderBigTwo></div>
                                ) : (
                                    <div>

                                        <div class="relative overflow-x-auto">
                                            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                                <thead class="">
                                                    <tr>
                                                        <th scope="col" class="px-6 py-3">

                                                            <h1 className="TableHeaderText" >Name</h1>

                                                        </th>
                                                        <th scope="col" class="px-6 py-3">

                                                            <h1 className="TableHeaderText" >Amount</h1>

                                                        </th>

                                                        <th scope="col" class="px-6 py-3">
                                                            <h1 className="TableHeaderText" >Due Date</h1>
                                                        </th>

                                                        <th scope="col" class="px-6 py-3">
                                                            <h1 className="TableHeaderText" >Remainder</h1>
                                                        </th>
                                                        <th scope="col" class="px-6 py-3">
                                                            <h1 className="TableHeaderText" >Details</h1>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {
                                                    currentItemsTwo.map((all, index) => (

                                                        <tbody key={index} className='w-full text-sm text-left text-gray-500 dark:text-gray-400'>
                                                            <tr class="bg-white dark:bg-gray-800">
                                                                <th scope="row" class="px-6 py-4 tableBodyText dark:text-white">
                                                                    {all.StudentsJobID}
                                                                </th>
                                                                <th scope="row" class="px-6 py-4 tableBodyText dark:text-white">
                                                                    {all.inputData}
                                                                </th>
                                                                <td class="px-6 py-4">
                                                                    {all.StartDate}
                                                                </td>
                                                                <td class="px-6 py-4">
                                                                    {all.EndDate}
                                                                </td>


                                                                <td>
                                                                    <Link to={`/dashboardTwo/SuperInvoiceDetails/${all._id}`}>
                                                                        <button className='text-white bg-orange-500 w-20 h-10 rounded-lg'>View</button>
                                                                    </Link>
                                                                </td>


                                                            </tr>
                                                        </tbody>

                                                    ))
                                                }
                                              <thead class="">
                                                <tr>
                                                    <th scope="col" class="px-6 py-3">


                                                    </th>
                                                    <th scope="col" class="px-6 py-3">

                                                        <h1 className="TotalText" >Total: {totalInputDataVerify}</h1>

                                                    </th>

                                                    <th scope="col" class="px-6 py-3">
                                                    </th>

                                                    <th scope="col" class="px-6 py-3">
                                                    </th>
                                                    <th scope="col" class="px-6 py-3">

                                                    </th>
                                                </tr>
                                            </thead>
                                            </table>
                                        </div>


                                        <div className='flex items-center justify-center mt-10'>
                                            <nav aria-label="Page navigation example">
                                                <ul className="inline-flex -space-x-px text-sm">
                                                    <li>
                                                        <button
                                                            onClick={() => handlePageChangeTwo(currentPageTwo - 1)}
                                                            className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${currentPageTwo === 1 ? 'opacity-50 cursor-not-allowed' : ''
                                                                }`}
                                                        >
                                                            Previous
                                                        </button>
                                                    </li>
                                                    {generatePaginationButtonsTwo()}
                                                    <li>
                                                        <button
                                                            onClick={() => handlePageChangeTwo(currentPageTwo + 1)}
                                                            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${currentPageTwo === totalPageCountTwo ? 'opacity-50 cursor-not-allowed' : ''
                                                                }`}
                                                        >
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                )}

                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SuperInvoice;